import React from 'react';
import InfoContainer from './InfoContainer';

interface Props {
  className?: string;
  name: string;
  address: string;
  taxId: string;
  clinicLocation: string;
}

const PayeeInfo = ({ name, address, taxId, clinicLocation, className }: Props) => {
  return (
    <InfoContainer className={className}>
      <p>
        <strong>{name}</strong>
      </p>
      <p>{address}</p>
      <p>Tax ID: {taxId}</p>
      <p>Clinic Location: {clinicLocation}</p>
    </InfoContainer>
  );
};

export default PayeeInfo;
